/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Pc_Dl_Meta_TitleInputs */

const en_pc_dl_meta_title = /** @type {(inputs: Pc_Dl_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`PdfCraft Download ${i?.version}: Free for Windows, Mac & Linux`)
};

const zh_pc_dl_meta_title = /** @type {(inputs: Pc_Dl_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`PdfCraft 下载 ${i?.version}：Windows、Mac、Linux 免费版`)
};

/**
* | output |
* | --- |
* | "PdfCraft Download {version}: Free for Windows, Mac & Linux" |
*
* @param {Pc_Dl_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_meta_title = /** @type {((inputs: Pc_Dl_Meta_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Meta_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_meta_title(inputs)
	return zh_pc_dl_meta_title(inputs)
});
export { pc_dl_meta_title as "pc.dl.meta_title" }